import {
        FETCH_ALL_TAREFAS_PROFESSOR,
        FETCH_ALL_CURSO_COORDENADOR,
        FETCH_ALL_TURMA_PROFESSOR,
        REMOVER_TAREFA,
        SET_NOTA_ALUNO_DESEMPENHO,
        FETCH_ALL_ALUNOS_DESEMPENHO_TAREFAS,
        FETCH_ALL_DISCIPLINAS_TAREFAS_PROFESSOR,
        FETCH_ALL_TAREFAS_ALUNO,
        FETCH_ALL_COMPONENTES} from '../actions/tarefaAction';

const INITIAL_STATE = { 
                        disciplina                   : null,
                        nome_turma                   : null,
                        statusMissao                 : null,
                        all_tarefas                  : [],
                        all_curso_coordenador        : [],
                        all_turma_professor          : [],
                        all_alunos_desempenho_tarefa : [],
                        all_tarefas_aluno            : [],
                        all_componentes_tarefa       :[]
                      };

export default function(state = INITIAL_STATE,action){

    switch (action.type) {

        case FETCH_ALL_TAREFAS_PROFESSOR:
  
            return { ...state, 
                     all_tarefas : (action.payload.data.tarefas ? action.payload.data.tarefas:[]), 
                     disciplina  : action.payload.data.disciplina
                    
                    }
 
        case FETCH_ALL_TAREFAS_ALUNO:
           return { ...state, all_tarefas_aluno:(action.payload.data?action.payload.data:[]) }

        case FETCH_ALL_CURSO_COORDENADOR:
           
           return { ...state, all_curso_coordenador:(action.payload.data?action.payload.data:[]) }

        case FETCH_ALL_TURMA_PROFESSOR:
           
           return { ...state, all_turma_professor:action.payload.data }

        case FETCH_ALL_ALUNOS_DESEMPENHO_TAREFAS:
           
           return { ...state, all_alunos_desempenho_tarefa:action.payload.data }

        case FETCH_ALL_COMPONENTES:

            return { ...state, all_componentes_tarefa:action.payload.data.dados,
                               nome_turma:action.payload.data.turma,
                               statusMissao  : action.payload.data.status,
                               pro_criador  : action.payload.data.professor,
                     }

        case REMOVER_TAREFA:
         
            return { ...state, all_tarefas : state.all_tarefas.filter(item => item.tar_id !== action.payload) }

        case SET_NOTA_ALUNO_DESEMPENHO:

            const dados  = state.all_componentes_tarefa;
            const filtro = dados.filter((item) =>{

                if (item.use_id === (action.payload.data.ent_tar_flag_entrega_equipe == 0 ? action.payload.data.ent_tar_cod_aluno : action.payload.data.ent_tar_cod_equipe) ) {
                     item.ent_tar_pontuacao = action.payload.data.ent_tar_pontuacao;
                     item.ent_tar_feedback = action.payload.data.ent_tar_feedback;
                     return item;

                }

                else {
                    return item;
                }

            });

            return { ...state, all_componentes_tarefa: filtro}


        case FETCH_ALL_DISCIPLINAS_TAREFAS_PROFESSOR:
            
            return { ...state, all_disciplinas_tarefas: (action.payload.data ? action.payload.data : []) }


        default:
           return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/reducer_tarefas.js